export default __webpack_public_path__ + "static/media/Delete.b619a396.svg";